export default __webpack_public_path__ + "static/media/ic-call-us.9f19efa1.svg";